import React from 'react'

class PositionInfo extends React.Component {
    render() {
        const pos = this.props.position
        return (
            <div id="kr-position">
                <div>
                    <span>X: {pos ? Math.round(pos.x) : '-'}</span>
                </div>
                <div>
                    <span>Y: {pos ? Math.round(pos.y) : '-'}</span>
                </div>
                <div>
                    <span>Z: {pos ? Math.round(pos.z) : '-'}</span>
                </div>
            </div>
        )
    }
}

export default PositionInfo
